import styled from "styled-components";
import SVG from "react-inlinesvg";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 75px;
    padding: 0 10px;
    @media (min-width: 720px) {
        margin-top: 40px;
        margin-left: 200px
    }
    @media (orientation: landscape) and (max-width: 1080px){
        margin-left: 25px
    }
`;

export const PageTitle = styled.h1`
    color: #006560;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    @media (min-width: 720px) {
        text-align: start;
    }
`;

export const CountContainer = styled.span`
    color: #9BA8C3;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 160%;
`;

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    margin-block: 25px;
    gap: 25px;
    @media (min-width: 720px) {
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }
`;

export const ContainerList = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    background: #F2F2F2;
    gap: 12px;
    padding: 10px;
    border-radius: 10px;
    @media (min-width: 720px) {
        width: 95%;
    }
`;

export const LineTitle = styled.div`
    display: flex;
    width: 98%;
    flex-direction: row;
    align-items: center;
    justify-content: ${props => props.$align ? props.$align : 'space-between'};
    padding: 10px;
`;

export const TitleText = styled.h1`
    width: ${props => props.width ? props.width : '20%'};
    color: #333;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    white-space: nowrap;
    text-align: ${props => props.$align ? props.$align : 'start'};
    max-width: 30%;
    overflow: auto;
    &::-webkit-scrollbar {
        height : 3px;
    }
    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const LineList = styled.a`
    display: flex;
    width: 98%;
    flex-direction: row;
    align-items: center;
    background: #FFF;
    justify-content: ${props => props.$align ? props.$align : 'space-between'};
    border-radius: 10px;
    padding: 10px;
    cursor: pointer;
    text-decoration: none;
`;

export const ListText = styled.h1`
    width: ${props => props.width ? props.width : '20%'};
    color: #333;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    white-space: nowrap;
    max-width: 30%;
    overflow: hidden;
    text-align: ${props => props.$align ? props.$align : 'start'};
    text-overflow: ellipsis;
`;

export const ListButton = styled.button`
    color: #33CC99;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    white-space: nowrap;
    background: none;
    outline: none;
    border: none;
    cursor: pointer;
    padding-inline: 5px;
    border-radius: 5px;
    &:disabled{
        background: #A3A3A3;
        color: #fff;
        cursor: auto;
    }
`;

export const FilterInput = styled.input`
    border: none;
    outline: none;
    color: #333;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 100%; /* 20px */
`;

export const InputContainer = styled.div`
    display: flex;
    padding: 12px 22px 12px 20px;
    justify-content: center;
    align-items: center;
    gap: 15px;
    border-radius: 10px;
    border: 1px solid #3C9;
`;

export const ContainerHead = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 15px;
    @media (min-width: 720px) {
        width: 95%;
        flex-direction: row;
    }
`;

export const ContainerRow = styled.form`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 90%;
    overflow: auto;
    @media (min-width: 1320px) {
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 25px;
    padding-bottom: 20px;
    // flex-direction: column;
    justify-self: flex-end;
    @media (min-width: 1320px) {
        width: 90%;
        justify-content: flex-end;
        flex-direction: row;
    }
`;

export const ContainerColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
    padding: 20px;
    align-items: center;
    justify-content: flex-start;
    gap: 15px;
    @media (min-width: 1320px) {
        width: 30%;
    }
`;

export const HelpIcon = styled(SVG)`
    width: 24px;
    height: 24px;
    & path {
        fill: currentColor;
    }
`;